import type { FC } from 'react'
import type { SortWrapperProps } from './types'

export const SortWrapper: FC<SortWrapperProps> = ({
  children,
  isSortable = false,
  onSort,
}) =>
  isSortable && typeof onSort !== 'undefined' ? (
    <button type="button" onClick={() => onSort()} className="h-full w-full">
      {children}
    </button>
  ) : (
    children
  )
